import { createApp } from '@app/adapters/create-app'

import PDFTron from '../sections/pdftron'

onDomLoad(function ($dom) {
  $dom.find("[data-behaviour='pdftron-document-viewer']").each(function () {
    const data = this.dataset

    createApp(PDFTron, {
      path: data.path,
      initialDocs: JSON.parse(data.documentUrls),
      ownerId: data.ownerId,
      ownerType: data.ownerType,
      enableAnnotations: data.enableAnnotations === 'true',
      enableAnnotationsToolbar: data.enableAnnotationsToolbar === 'true',
      class: data.class,
      disableMouseWheelZoom: data.disableMouseWheelZoom === 'true',
      enableAiProposalDrawer: data.enableAiProposalDrawer === 'true',
      hideTabButtons: data.hideTabButtons === 'true',
    }).mount(this)
  })
})
